import React, { ReactNode } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getEventRestrictionInitialValues } from '~admin/view/components/create-event/helper/create-event-initial-values.helper';
import { Box } from '~common/components/box.component';
import { Button } from '~common/components/button/button.component';
import { Size } from '~common/components/button/button.helper';
import { Column } from '~common/components/column.component';
import { Color } from '~common/model/basics';
import { PlusIcon } from '~web/view/components/ui/icon/plus.icon';
import {
  EventRestrictionItemFields,
  EventRestrictionItemFormData,
} from '~admin/view/components/details/event-details/event-restrictions/event-restriction-item-fields.component';

export interface EventRestrictionsFormData {
  eventRestrictions?: EventRestrictionItemFormData[];
}

export const EventRestrictions: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <FieldArray name={'eventRestrictions'}>
        {({ fields }): ReactNode => {
          const onRemove = (index: number): void => {
            fields.remove(index);
          };

          const onAdd = (): void => {
            fields.push(getEventRestrictionInitialValues());
          };

          return (
            <>
              {fields.map((name: string, index: number) => (
                <EventRestrictionItemFields
                  key={name}
                  name={name}
                  onRemove={(): void => onRemove(index)}
                />
              ))}
              <Box>
                <Button color={Color.White} size={Size.Small} onClick={onAdd}>
                  <StyledPlusIcon color={Color.Black} width={14} height={14} />
                  {t('createEvent.eventDetails.restrictions.addButton')}
                </Button>
              </Box>
            </>
          );
        }}
      </FieldArray>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

const StyledPlusIcon = styled(PlusIcon)`
  fill: currentColor;
  margin-right: 12px;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-restrictions/event-restrictions.component.tsx